import { render, staticRenderFns } from "./TakipHazirlaniyor.vue?vue&type=template&id=2ae71987&scoped=true"
import script from "./TakipHazirlaniyor.vue?vue&type=script&lang=ts"
export * from "./TakipHazirlaniyor.vue?vue&type=script&lang=ts"
import style0 from "./TakipHazirlaniyor.vue?vue&type=style&index=0&id=2ae71987&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae71987",
  null
  
)

export default component.exports